import { ChakraProvider, theme } from '@chakra-ui/react';
import { Routes, Route } from 'react-router-dom';
import { SignIn } from './components/SignIn';
import { NavBar } from './components/NavBar';
import { SignUp } from './components/SignUp';
import { SignedIn } from './components/SignedIn';

export const App = () => {
  return (
    <ChakraProvider theme={theme}>
      <Routes>
        <Route path='/' element={<NavBar />}></Route>
        <Route path='/sign-in' element={<SignIn />}></Route>
        <Route path='/signed-in' element={<SignedIn />}></Route>
        <Route path='/sign-up' element={<SignUp />}></Route>
      </Routes>
    </ChakraProvider>
  );
};
